import { normalizeCustomerAccountCode, normalizeInvoiceReferenceCode } from "./lookupCode";

export const routePaths = {
  root: "/",
  styleGuide: "/style-guide",
  loginTest: "/login-test",
  signIn: "/sign-in",
  portal: {
    base: "/portal",
    overview: "/",
    invoice: "/invoices/:invoiceCode",
    linkedAccounts: "/linked-accounts",
  },
  search: "/pay",
  accountDetail: "/pay/account/:customerCode",
  invoice: "/pay/invoice/:invoiceCode",
} as const;

export const routes = {
  root: () => routePaths.root,
  signIn: (returnTo?: string) =>
    returnTo ? `${routePaths.signIn}?${new URLSearchParams({ returnTo })}` : routePaths.signIn,
  styleGuide: () => routePaths.styleGuide,
  loginTest: (returnTo?: string) =>
    returnTo
      ? `${routePaths.loginTest}?${new URLSearchParams({ returnTo })}`
      : routePaths.loginTest,
  portal: {
    overview: () => routePaths.portal.base,
    pay: (customAmount = false) =>
      `${routePaths.portal.base}/pay${customAmount ? "?amount=custom" : ""}`,
    invoice: (reference: string) =>
      `${routePaths.portal.base}/invoices/${encodeURIComponent(normalizeInvoiceReferenceCode(reference))}`,
    payment: (id: string) => `${routePaths.portal.base}/payments/${encodeURIComponent(id)}`,
    history: (tab: "invoices" | "payments") =>
      `${routePaths.portal.base}/billing-history?tab=${tab}`,
    linkedAccounts: () => `${routePaths.portal.base}${routePaths.portal.linkedAccounts}`,
  },
  search: () => routePaths.search,
  accountDetail: (customerCode: string) =>
    `/pay/account/${encodeURIComponent(normalizeCustomerAccountCode(customerCode))}`,
  invoice: (invoiceCode: string) =>
    `/pay/invoice/${encodeURIComponent(normalizeInvoiceReferenceCode(invoiceCode))}`,
};
